import React from 'react'
import { addimage } from '../../../assets'
import { Input, Dropdown, Button, FileInput } from '../../../components/Generic'

const SettingProfData = () => {
  return (
    <div className='flex mt-[100px] flex-col justify-center items-center '>
        <FileInput>
        <img src={addimage} alt="" />
        </FileInput>
        <div className='text-[18px] mt-[23px] font-medium'>Set Photo</div>
        <div className='w-full mt-[30px] md:w-[388px] gap-[20px] flex flex-col'>
        <div className='justify-start text-gray-lightGray text-[15px]'>Fill in the following information</div>
            <Input mb={true} style={`h-[60px] px-[18px]`} placeholder='F.I.SH'/>
            <Input mb={true} style={`h-[60px] px-[18px]`} placeholder='dd.mm.yyyy'/>
            <Input mb={true} style={`h-[60px] px-[18px]`} placeholder='Address'/>
            <Input mb={true} style={`h-[60px] px-[18px]`} placeholder='Username'/>
            <Input mb={true} style={`h-[60px] px-[18px]`} placeholder='Create password'/>
            <Input mb={true} style={`h-[60px] px-[18px]`} placeholder='Confirm password'/>
            <div>
            <Input mb={true} style={`h-[60px] px-[18px]`} placeholder='Telegram Link'/>
            <div className='mt-[5px] mb-[12px] text-[13px] font-inter text-gray-optionalGray'>Optional</div>
            <Input mb={true} style={`h-[60px] px-[18px]`} placeholder='Instagram link'/>
            <div className='mt-[5px] mb-[12px] text-[13px] font-inter text-gray-optionalGray'>Optional</div>
            <Input mb={true} style={`h-[60px] px-[18px]`} placeholder='Facebook link'/>
            <div className='mt-[5px] mb-[12px] text-[13px] font-inter text-gray-optionalGray'>Optional</div>
            <Dropdown defaultOption='Select Specialty' optionss={['Teacher', 'Student']}/>
            </div>
            <Dropdown defaultOption='Select Gender' optionss={['Male', 'Female']}/>
            <Button value={'Next'} style={`mb-[100px]`}/>
        </div>
    </div>
  )
}

export default SettingProfData